import { render, staticRenderFns } from "./threeDimMultiPlayer.vue?vue&type=template&id=635c9baa&scoped=true"
import script from "./threeDimMultiPlayer.vue?vue&type=script&lang=js"
export * from "./threeDimMultiPlayer.vue?vue&type=script&lang=js"
import style0 from "./threeDimMultiPlayer.vue?vue&type=style&index=0&id=635c9baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c9baa",
  null
  
)

export default component.exports